export default __webpack_public_path__ + "static/media/walks_300.fd924956.webp";